module.exports = __webpack_public_path__ + "4bcf4ef07d0fe93a0b61e0456bc3ea9a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/forest.png
// module id = 2750
// module chunks = 0